export const BackIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='13.712'
      viewBox='0 0 16 13.712'
    >
      <path
        id='Path_50324'
        data-name='Path 50324'
        d='M.216,70.5a.573.573,0,0,0,0,.807L6.5,77.6a.571.571,0,0,0,.807-.807L2,71.478h13.48a.571.571,0,0,0,0-1.143H2L7.31,65.023a.571.571,0,0,0-.807-.807L.216,70.5Z'
        transform='translate(-0.05 -64.05)'
        fill='#0153ff'
      />
    </svg>
  );
};
